import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import { getDiscountSagaAction, removeDiscountSagaAction, sortSagaAction } from "../../redux/sagaActions";

const Discounts = () => {
    const dispatch = useDispatch();
    const discount = useSelector(state => state.discount);

    const [list, setList] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...discount.filter(elem => elem.name !== 'Нет скидки')];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'discount',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    return (
        <div className="settings">
            <ReactSortable
                list={ list }
                setList={ setList }
                handle={ '.control--move' }
                onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
            >
                {
                    discount.filter(elem => elem.name !== 'Нет скидки').map(elem => {
                        return (
                            <div className="setting" key={ elem.id }>
                                <div className="controls">
                                    <i className="control control--edit" onClick={ () => {
                                        dispatch(getDiscountSagaAction({ discount_id: elem.id }));
                                    } } />
                                    <i className="control control--move" />
                                    <i className="control control--remove" onClick={ () => {
                                        if (window.confirm('Вы действительно хотите удалить этоу скидку?')) {
                                            dispatch(removeDiscountSagaAction({ id: elem.id }));
                                        }
                                    } } />
                                </div>
                                <div className="setting__caption">{ elem.name }</div>
                            </div>
                        )
                    })
                }
            </ReactSortable>
        </div>
    );
};

export default Discounts;